import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7.5 15a7.5 7.5 0 100-15 7.5 7.5 0 000 15z" fill="#fff" /><path d="M6.406 8.277h1.665V3.125H6.406v5.152zM6.34 11h1.8V9.256h-1.8V11z" fill="#FFA800" /></svg>);